export default __webpack_public_path__ + "static/media/GreenFrame03.b61d5707.png";